import { captureException } from "@sentry/react";

export const getEzioId = () => {
    const params = new URLSearchParams(location.search);

    const previousDeviceId = localStorage.getItem("ezioId");
    const currentDeviceId = params.get("id");

    if (
        import.meta.env.MODE === "production" &&
        previousDeviceId &&
        (currentDeviceId === null || previousDeviceId !== currentDeviceId)
    ) {
        // This avoids a race condition. Sentry typically hasn't finished loading at this point, so it will miss console errors.
        setTimeout(
            () =>
                captureException(
                    new Error(
                        `Previous deviceId '${previousDeviceId}' does not match current deviceId '${currentDeviceId}'`
                    )
                ),
            3000
        );
    }

    if (currentDeviceId) {
        localStorage.setItem("ezioId", currentDeviceId);
        return currentDeviceId;
    }

    if (previousDeviceId) return previousDeviceId;

    console.warn("No ezio id provided");
    return undefined;
};
